import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';
import { setValues, setCuttingDetails } from '../../Actions/Configurator.action';

const PanelMarking = ({ id, IsPopup }) => {
  const dispatch = useDispatch(),
    articleNumber = useSelector((state) => state.configurator.id),
    configurator = useSelector((state) => state.configurator),
    { selections, rules } = configurator;

  let cuttingDetail = selections.cuttingDetails.find((x) => x.id == id);
  let marking = cuttingDetail && cuttingDetail.marking;
  const [workPhaseMarkingText, setWorkPhaseMarkingText] = useState((marking && marking.workPhaseMarkingText) || ''),
    [drawingNumber, setDrawingNumber] = useState((marking && marking.drawingNumber) || ''),
    [workPhaseMarkingChargeNumber, setWorkPhaseMarkingChargeNumber] = useState((marking && marking.workPhaseMarkingChargeNumber) || false),
    [goodsMarking, setGoodsMarking] = useState((marking && marking.goodsMarking) || '');

  useEffect(() => {
    let data = {
      drawingNumber,
      workPhaseMarkingChargeNumber,
      workPhaseMarkingText,
      goodsMarking,
      description: (marking && marking.description) || '',
      inkjetIntegrationFlagIfCuttingOperation: rules && rules.inkjetIntegrationFlagIfCuttingOperation,
    };

    if (drawingNumber || workPhaseMarkingChargeNumber || workPhaseMarkingText || goodsMarking) {
      data.description = translate('marking.description');

      if (drawingNumber) {
        data.description += ` - ${drawingNumber}`;
      }

      if (workPhaseMarkingChargeNumber) {
        data.description += ` - ${translate('checkout.cart.specification.workphasemarkingchargenumber.true')}`;
      }

      if (workPhaseMarkingText) {
        data.description += ` - ${workPhaseMarkingText}`;
      }
      if (goodsMarking) {
        data.description += ` - ${goodsMarking}`;
      }
    }

    if (id) {
      dispatch(setCuttingDetails(id, 'marking', data));
    } else {
      dispatch(setValues({ marking: data }));
    }
  }, [workPhaseMarkingText, drawingNumber, workPhaseMarkingChargeNumber, goodsMarking]);

  const updateInkJetIntegrationFlag = (value) => {
    setWorkPhaseMarkingChargeNumber(value);
    googleAnalyticsProductConfigurator('workPhaseMarkingChargeNumber', value.toString(), articleNumber);

    if (value === true) {
      setWorkPhaseMarkingText('');
    }
  };

  const updateWorkPhaseMarkingText = (value, isBlur) => {
    setWorkPhaseMarkingText(value);

    if (isBlur) {
      googleAnalyticsProductConfigurator('workPhaseMarkingText', value.toString(), articleNumber);
    }
  };

  const updateDrawingsNumber = (value, isBlur) => {
    setDrawingNumber(value);

    if (isBlur) {
      googleAnalyticsProductConfigurator('drawingNumber', value.toString(), articleNumber);
    }
  };
  const updateGoodsMarking = (value, isBlur) => {
    setGoodsMarking(value);

    if (isBlur) {
      googleAnalyticsProductConfigurator('goodsMarking', value.toString(), articleNumber);
    }
  };

  return (
    <div className={'configurator-box' + (IsPopup ? ' configurator-box--popup' : '')}>
      <header>
        <h4 className='configurator-box__title'>
          {translate('beamtype.markingtitle')}
        </h4>
      </header>

      <div className='configurator-box__content'>
        <label className='configurator-input-duo'>
          <span>{translate('beamtype.drwaingnumber')}</span>
          <input type='text' className='configurator-input' placeholder={translate('blasting.none')} value={drawingNumber}
            onChange={(event) => { updateDrawingsNumber(event.target.value, false); }} onBlur={(event) => { updateDrawingsNumber(event.target.value, true); }}
          ></input>
        </label>

        <header>
          <h4 className='configurator-box__title'>
            {translate('beamtype.printmarkingdetails')}
          </h4>
        </header>

        <label className='configurator-input-duo'>
          <span>{translate('beamtype.medchargenumber')}</span>
          <span className='configurator-checkbox'>
            {translate('beamtype.yeslabel')}
            <input type='checkbox' checked={workPhaseMarkingChargeNumber > 0} onChange={(event) => updateInkJetIntegrationFlag(event.target.checked)}
            ></input>
          </span>
        </label>

        <label className='configurator-input-duo'>
          <span>{translate('beamtype.medtext')}</span>
          <input type='text' className='configurator-input' placeholder={translate('beamtype.angletext')} disabled={workPhaseMarkingChargeNumber > 0}
            value={workPhaseMarkingText} onChange={(event) => { updateWorkPhaseMarkingText(event.target.value, false); }}
            onBlur={(event) => { updateWorkPhaseMarkingText(event.target.value, true); }} />
        </label>
        {IsPopup &&
          <Fragment>
            <div className='configurator-input-duo configurator-input-duo--goods'>
              <span>
                <svg className='configurator-box__icon'>
                  <use href='/ui/images/sprites/be-group.svg#marking'></use>
                </svg>
                {translate('configurator.goodsmarking.key')}
              </span>
              <input type='text'
                className='configurator-input' placeholder={translate('beamtype.placeholder.goodsmarking')} value={goodsMarking}
                onChange={(event) => { updateGoodsMarking(event.target.value, false); }} onBlur={(event) => { updateGoodsMarking(event.target.value, true); }} />
            </div>
            <div>{translate('configurator.goodsmarking.orderlinemessage')}</div>
          </Fragment>
        }
      </div>
    </div>
  );
};

export default PanelMarking;
